import { QTD_DEPENDENTES_ENUM } from '../helpers/funcoesPadroes';
import {
    validatorParentescoEmDuplicidade,
    retornaLabelDoValorParentesco,
    idadeAte65,
    idadeAcima65,
    validarLimiteCategoria,
    validarCategoria,
    validarExisteDoisDependAcima65Anos
} from './funcoesAuxiliaresZFL';

export class CorrenteCadastroZFL {
    constructor(dependentes, parentesco, categorias, valoresForm, idadeAssociado) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.categoriaSelecionada = valoresForm.Categoria;
        this.qtdDependentes = this.dependentes.length;
        this.idadeAssociado = idadeAssociado;
    }

    verificarPossui5Dependentes() {
        if (this.qtdDependentes === QTD_DEPENDENTES_ENUM.cinco) {
            this.arrayMsgsErro.push('Este plano só é permitido 5 dependentes.');
        }

        return this;
    }

    validaSequenciaDependentes() {
        const { Categoria } = this.valoresForm;

        if (Categoria && Categoria !== 'ZELO' && this.qtdDependentes < 4) {
            this.arrayMsgsErro.push(
                'Para até 4 dependentes só pode ser selecionado sem valor adicional.'
            );
        } else if (Categoria && Categoria === 'ZELO' && this.qtdDependentes === 4) {
            this.arrayMsgsErro.push(
                'O quinto dependente deverá ser cobrado o valor adicional.'
            );
        }

        return this;
    }

    validarCategoriasPlano() {
        switch (this.valoresForm.Categoria.trim()) {
            case 'ZELO':
                if (!validarLimiteCategoria(this.dependentes, 'ZELO', 4)) {
                    this.arrayMsgsErro.push(
                        'O máximo de dependentes sem valor adicional são quatro dependentes.'
                    );
                }

                break;
            case 'ZTA64':
                if (!validarLimiteCategoria(this.dependentes, 'ZTA64', 1)) {
                    this.arrayMsgsErro.push(
                        'O máximo de dependentes pela categoria ZELO ATÉ 64 ANOS é um dependente.'
                    );
                }

                break;
            case 'ZTM65':
                if (!validarLimiteCategoria(this.dependentes, 'ZTM65', 1)) {
                    this.arrayMsgsErro.push(
                        'O máximo de dependentes pela categoria ZELO ATÉ 64 ANOS é um dependente.'
                    );
                }

                break;
        }

        if (this.valoresForm.Categoria && this.valoresForm.Categoria !== 'ZELO') {
            if (!validarCategoria(this.dependentes, this.valoresForm.Categoria)) {
                this.arrayMsgsErro.push(
                    'Para este plano só pode ser inserido um dependente especial.'
                );
            }
        }

        return this;
    }

    parentescoEpecialComAdicionalAte65() {
        if (this.valoresForm.Idade && idadeAte65(this.valoresForm.Idade)) {
            if (this.valoresForm.Categoria && this.valoresForm.Categoria === 'ZTM65') {
                this.arrayMsgsErro.push(
                    'A categoria selecionada não corresponde a idade do dependente.'
                );
            }
        }

        return this;
    }

    parentescoEspecialComAdicionalMaior65() {
        if (this.valoresForm.Idade && idadeAcima65(this.valoresForm.Idade)) {
            if (this.valoresForm.Categoria && this.valoresForm.Categoria === 'ZTA64') {
                this.arrayMsgsErro.push(
                    'A categoria selecionada não corresponde a idade do dependente.'
                );
            }
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }

    validarQtdDependentesAcima65Anos() {
        if (
            validarExisteDoisDependAcima65Anos(
                this.dependentes,
                this.valoresForm.Idade,
                this.idadeAssociado
            )
        ) {
            this.arrayMsgsErro.push(
                'Neste plano só é permitido duas pessoas acima de 64 anos, incluindo o titular.'
            );
        }

        return this;
    }
}
